<template>
  <div class="filterSet">
    <h3>{{ title }}</h3>
    <transition-group name="checkbox">
      <div 
        class="checkbox" 
        v-for="filter in limitedOptions" :key="filter"
        aria-checked="false"
      >
        <input 
          type="checkbox" 
          :value="filter" 
          class="categoryInputs" 
          :id="id(filter)"
          v-model="model"
          @keyup.enter="check(filter)"
        >
        <label :for="id(filter)" >{{ filter }}</label>
      </div>
    </transition-group>
    <button 
      v-if="limit"
      class="showAllFilters"
      @click="toggleFilters"
    >
      {{ toggleText }}
    </button>
  </div>
</template>

<script>
export default {
  name: "FilterSet",
  props: {
    title: String,
    options: Array,
    modelValue: Array,
    limit: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      model: this.modelValue,
      displayAll: false,
    }
  },
  computed: {
    limitedOptions() {
      // console.log('limit: ', this.limit)
      return (this.limit && !this.displayAll) ? this.options.slice(0, this.limit) : this.options
    },
    toggleText() {
      const count = this.options.length - this.limit

      return (this.displayAll) ? `- Hide` : `+ Show ${count} more`
    }
  },
  watch: {
    modelValue: function(val) {
      this.model = val
    },
    model: function(val) {
      this.$emit('update:modelValue', val)
      this.$router.push({ name: 'Page', params: { page: '1' } })
    },
  },
  methods:{
    check(filter) {
      document.getElementById(this.id(filter))?.click()
    },
    id(name) {
      let id = `${this.title}--${name}`

      // Strip quotes, commas, periods, hashes
      id = id.replace(/"|,|\.|#/g, '');
      // Remove spaces
      id = id.replace(/\s-\s|\s+/g, '-');

      return id.trim().toLowerCase()
    },
    toggleFilters() {
      this.displayAll = (this.displayAll) ? false : true
    }
  }
};
</script>

<style scoped lang="scss">
  .checkbox-enter-active,
  .checkbox-leave-active {
    transition: all 0.4s ease-in-out;
  }

  .checkbox-enter-from,
  .checkbox-leave-to {
    opacity: 0;
    transform: scale(0);
  }

  h3 {
    margin: 30px 0 20px;
  }
</style>